import { notFound } from "next/navigation";
import { useQuery } from "@tanstack/react-query";

import {
  applicationByAliasDefaultValues,
  applicationQueryKey,
} from "@/hooks/apis/queries/useApplicationByAliasQuery/constants";
import type { IApplicationByAliasHookQuery } from "@/hooks/apis/queries/useApplicationByAliasQuery/types";

import { applicationsApiHandler } from "@/services/apiHandlers/applications";

const useApplicationByAliasQuery = ({
  appAlias,
  application,
  projectId,
  enabled = false,
}: IApplicationByAliasHookQuery) => {
  const initialData = application && { initialData: application };
  const {
    data: applicationByAlias = applicationByAliasDefaultValues,
    isLoading: isLoadingApplicationByAlias,
    refetch,
    error,
  } = useQuery({
    queryKey: [applicationQueryKey, appAlias, projectId],
    queryFn: () =>
      applicationsApiHandler.getApplicationByAlias({
        alias: appAlias,
        projectId,
      }),
    enabled,
    ...initialData,
  });

  if (error) {
    notFound();
  }

  return {
    applicationByAlias,
    refetch,
    isLoadingApplicationByAlias,
  };
};

export default useApplicationByAliasQuery;
